import { render } from "./detailsTable.vue?vue&type=template&id=8b6ec9f2&scoped=true"
import script from "./detailsTable.vue?vue&type=script&lang=js"
export * from "./detailsTable.vue?vue&type=script&lang=js"

import "./detailsTable.vue?vue&type=style&index=0&id=8b6ec9f2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6ec9f2"]])

export default __exports__